import React from 'react';
import Navbar from '../includes/navbar'
import Carousel from '../includes/carousel'
import Footer from '../includes/footer'
import Loading from '../includes/loading'
import {usePageTitle} from "../helpers/page-title";
import {useTranslation} from "react-i18next";
import {useDetectLanguage} from "../helpers/language-detector";

export default function Home() {
    const { t } = useTranslation();

    usePageTitle(`${t('title.home')} | ${t('title.gaocna')}`);

    return (
        <>
            <div className="hero">
                <div className="box1"></div>
                <div className="box2">
                    <Carousel />
                </div>
                <div className="box3"></div>
            </div>
        </>
    );
}
